import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';

// Supported languages
export const LANGUAGES = {
  en: { label: 'English', flag: '🇺🇸' },
  es: { label: 'Español', flag: '🇪🇸' },
  fr: { label: 'Français', flag: '🇫🇷' },
} as const;

export type Language = keyof typeof LANGUAGES;

// Resources for i18next
const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
};

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'translation',

    // Detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'jetpacker-language',
    },

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // React specific options
    react: {
      useSuspense: false,
    },
  });

/**
 * Change the current language
 */
export const changeLanguage = (lang: Language) => {
  i18n.changeLanguage(lang);
  localStorage.setItem('jetpacker-language', lang);
};

/**
 * Get the current language
 */
export const getCurrentLanguage = (): Language => {
  return (i18n.language?.split('-')[0] || 'en') as Language;
};

/**
 * Backend language normalization (matches mobile app behavior)
 */
export const getBackendLanguage = (): 'es' | 'en' | 'fr' => {
  const language = getCurrentLanguage().toLowerCase();
  if (language === 'en' || language === 'fr') return language;
  return 'es';
};

export default i18n;
